// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"image-link-input_checkboxContainer__lj2zX","checkboxWrapper":"image-link-input_checkboxWrapper__wyqpg"};